export default "__VITE_ASSET__CVYw7EAu__"